const getLatestDate = (dates) => {
  return dates.reduce((prev, curr) => {
    const prevMillis = new Date(prev).getTime()
    const currMillis = new Date(curr).getTime()
    return currMillis > prevMillis ? curr : prev
  })
}

export const getDispatchDate = ({ order }) => {
  const dispatchDatesRange = order.getIn(['freight', 'dispatchBeforeDates'])
  const freightDate = dispatchDatesRange && getLatestDate(dispatchDatesRange)
  return order.get('dateDelivered') || freightDate
}

const KLARNA_PAYMENT_METHOD_CATEGORY_MAPPING = {
  invoice: 'pay_later',
  pay_later_by_card: 'pay_later',
  slice_it_by_card: 'pay_later',
  fixed_sum_credit: 'pay_over_time',
  direct_debit: 'pay_now',
  direct_bank_transfer: 'pay_now',
  pay_by_card: 'pay_now',
  alternative_payment_method: 'pay_now'
}

export const getKlarnaPaymentCategory = (paymentMethod) => {
  if (!paymentMethod) return

  const normalizedPaymentMethod =
    typeof paymentMethod?.toJS === 'function' ? paymentMethod.toJS() : paymentMethod

  const type = normalizedPaymentMethod?.type || normalizedPaymentMethod

  const category = KLARNA_PAYMENT_METHOD_CATEGORY_MAPPING[type] ?? 'klarna_default'

  return normalizedPaymentMethod?.type ? { type: category } : category
}
